import { defineMessages } from 'react-intl';

export const validatorAccountsMessages = defineMessages({
    validationAccounts: {
        id: 'validator-accounts',
        defaultMessage: 'Validator accounts',
    },
    validationAccount: {
        id: 'validator-account',
        defaultMessage: 'Validator account',
    },
    accounts: {
        id: 'accounts',
        defaultMessage: 'Accounts',
    },
    account: {
        id: 'account',
        defaultMessage: 'Account',
    },
    total: {
        id: 'total',
        defaultMessage: 'Total',
    },
    validationTypes: {
        id: 'validation-types',
        defaultMessage: 'Validation types',
    },
    validationTypesCount: {
        id: 'validation-types-count',
        defaultMessage: '{count, plural, one {# type} other {# types}}',
    },
    createValidatorAccountSuccess: {
        id: 'create-validator-account-success',
        defaultMessage: 'Validator account created',
    },
    createValidatorAccountSuccessDescription: {
        id: 'create-validator-account-success-description',
        defaultMessage: 'A new validator account has been successfully created.',
    },
    newValidatorAccount: {
        id: 'add-new-validator-account',
        defaultMessage: 'New validator account',
    },
    addValidatorAccountModalSubtitle: {
        id: 'add-validator-account-modal-subtitle',
        defaultMessage: 'Add a new validator account',
    },
    validatorAccountDashboard: {
        id: 'validator-account-dashboard',
        defaultMessage: 'Validator account dashboard',
    },
    activeAccount: {
        id: 'active-account',
        defaultMessage: 'Active',
    },
    inactiveAccount: {
        id: 'inactive-account',
        defaultMessage: 'Inactive',
    },
    deleteValidatorAccount: {
        id: 'delete-validator-account',
        defaultMessage: 'Delete validator account',
    },
    deleteValidatorAccountSubtitle: {
        id: 'delete-validator-account-subtitle',
        defaultMessage: 'Permanently delete {accountName}',
    },
    confirmDeleteValidatorAccount: {
        id: 'confirm-delete-validator-account',
        defaultMessage: 'Are you sure you want to delete {accountName}? This action cannot be undone.',
    },
    deleteValidatorAccountSuccess: {
        id: 'delete-validator-account-success',
        defaultMessage: 'Deleted',
    },
    deleteValidatorAccountSuccessDescription: {
        id: 'delete-validator-account-success-description',
        defaultMessage: 'Account {accountName} has been successfully deleted.',
    },
    editValidatorAccount: {
        id: 'edit-validator-account',
        defaultMessage: 'Edit validator account',
    },
    editValidatorAccountSubtitle: {
        id: 'edit-validator-account-subtitle',
        defaultMessage: 'Edit account details for {accountName}',
    },
    updateValidatorAccountSuccess: {
        id: 'update-validator-account-success',
        defaultMessage: 'Validator account updated',
    },
    updateValidatorAccountSuccessDescription: {
        id: 'update-validator-account-success-description',
        defaultMessage: 'The account has been successfully updated.',
    },
    deleteValidatorAccountError: {
        id: 'custom-error:failed_validator_account_deletion_due_to_related_validations',
        defaultMessage: 'The validator account could not be deleted as there are related validations!',
    },
    user: {
        id: 'user',
        defaultMessage: 'User',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    searchUser: {
        id: 'search-user',
        defaultMessage: 'Search user',
    },
    noUser: {
        id: 'no-user',
        defaultMessage: 'No user',
    },
    noUserFound: {
        id: 'no-user-found',
        defaultMessage: 'No user found',
    },
    cloudUsers: {
        id: 'cloud-users',
        defaultMessage: 'Cloud users',
    },
});
